(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[338],{

/***/ 4123:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/evolution-lifecycle",
      function () {
        return __webpack_require__(6200);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1652:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "K": function() { return /* binding */ BackToPageTop; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react-icons/io/index.esm.js
var index_esm = __webpack_require__(1649);
// EXTERNAL MODULE: ./src/constants/colors.tsx
var colors = __webpack_require__(9142);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 9 modules
var styled_components_browser_esm = __webpack_require__(4878);
// EXTERNAL MODULE: ./src/constants/spacing.tsx
var spacing = __webpack_require__(1036);
;// CONCATENATED MODULE: ./src/components/back-to-page-top/styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: ",
        ";\n  cursor: pointer;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}


const BackToPageTopContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-dca4a291-0"
})(_templateObject(), spacing/* spacing.xsm */.W.xsm);

// EXTERNAL MODULE: ./src/components/typograph/index.tsx + 1 modules
var typograph = __webpack_require__(8234);
;// CONCATENATED MODULE: ./src/components/back-to-page-top/index.tsx





const BackToPageTop = ()=>{
    const handleClick = ()=>{
        const root = document.getElementById("root");
        root.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BackToPageTopContainer, {
        onClick: handleClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IoIosArrowDropup */.zBn, {
                color: colors/* colors.green */.O.green,
                size: 22
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(typograph/* TypographSpan */.jA, {
                uppercase: true,
                size: 16,
                bold: true,
                lineHeight: 20.8,
                color: colors/* colors.text_white */.O.text_white,
                children: "voltar ao topo"
            })
        ]
    });
};


/***/ }),

/***/ 4925:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x": function() { return /* binding */ OurPillars; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./src/constants/colors.tsx
var colors = __webpack_require__(9142);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 9 modules
var styled_components_browser_esm = __webpack_require__(4878);
// EXTERNAL MODULE: ./src/constants/spacing.tsx
var spacing = __webpack_require__(1036);
;// CONCATENATED MODULE: ./src/components/our-pillars/styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n\n  @media (min-width: 750px) {\n    > ul {\n      display: grid;\n      grid-template-columns: 25% 25% 25% 25%;\n      gap: ",
        ";\n      flex-wrap: wrap;\n    }\n  }\n\n  @media (max-width: 750px) {\n    > ul {\n      display: flex;\n      flex-direction: column;\n      gap: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  height: 48px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  transition: 0.25s;\n  cursor: pointer;\n\n  @media (max-width: 750px) {\n    width: 100%;\n  }\n\n  &:hover {\n    filter: brightness(1.25);\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}


const OurPillarsContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7c9b4a8d-0"
})(_templateObject(), spacing/* spacing.sm */.W.sm, spacing/* spacing.md */.W.md, spacing/* spacing.sm */.W.sm);
const ButtonInfo = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-7c9b4a8d-1"
})(_templateObject1(), (param)=>{
    let { color  } = param;
    return color;
});

// EXTERNAL MODULE: ./src/components/typograph/index.tsx + 1 modules
var typograph = __webpack_require__(8234);
// EXTERNAL MODULE: ./src/enums/routes.ts
var routes = __webpack_require__(4285);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/components/our-pillars/index.tsx
/* eslint-disable react/no-array-index-key */ 





const OurPillars = ()=>{
    const buttons = [
        {
            color: colors/* colors.blue */.O.blue,
            textColor: colors/* colors.text_white */.O.text_white,
            text: "1. digital assessment",
            href: routes/* RoutesEnum.digital_assessment */.Xv.digital_assessment
        },
        {
            color: colors/* colors.purple */.O.purple,
            textColor: colors/* colors.text_white */.O.text_white,
            text: "2. digital blueprint",
            href: routes/* RoutesEnum.digital_blueprint */.Xv.digital_blueprint
        },
        {
            color: colors/* colors.light_green */.O.light_green,
            textColor: colors/* colors.black */.O.black,
            text: "3. performance racking",
            href: routes/* RoutesEnum.performance_racking */.Xv.performance_racking
        },
        {
            color: colors/* colors.green */.O.green,
            textColor: colors/* colors.black */.O.black,
            text: "4. evolution lifecycle",
            href: routes/* RoutesEnum.evolution_lifecycle */.Xv.evolution_lifecycle
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(OurPillarsContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(typograph/* TypographH3 */.mr, {
                uppercase: true,
                bold: true,
                color: colors/* colors.green */.O.green,
                size: 12,
                lineHeight: 16.8,
                children: "nossos pilares de atua\xe7\xe3o:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                children: buttons.map((btn, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: btn.href,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonInfo, {
                            color: btn.color,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typograph/* TypographSpan */.jA, {
                                uppercase: true,
                                bold: true,
                                size: 12,
                                lineHeight: 16.8,
                                color: btn.textColor,
                                children: btn.text
                            })
                        }, String(index))
                    }))
            })
        ]
    });
};


/***/ }),

/***/ 5720:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_": function() { return /* binding */ PageContainer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 9 modules
var styled_components_browser_esm = __webpack_require__(4878);
// EXTERNAL MODULE: ./src/constants/spacing.tsx
var spacing = __webpack_require__(1036);
// EXTERNAL MODULE: ./src/constants/colors.tsx
var colors = __webpack_require__(9142);
;// CONCATENATED MODULE: ./src/components/page-container/styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: max-content !important;\n  background-color: ",
        ";\n  display: flex;\n  margin-top: ",
        ";\n\n  > div {\n    width: 100%;\n    height: max-content !important;\n    max-width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: ",
        ";\n    margin-bottom: ",
        ";\n  }\n\n  @media (min-width: 750px) {\n    justify-content: center;\n    > div {\n      max-width: 960px;\n    }\n  }\n\n  @media (max-width: 750px) {\n    padding-left: ",
        ";\n    padding-right: ",
        ";\n    margin-top: ",
        ";\n\n    > div {\n      width: 100%;\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}



const PageContainerWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6b002171-0"
})(_templateObject(), colors/* colors.background */.O.background, spacing/* spacing.md */.W.md, spacing/* spacing.lg */.W.lg, spacing/* spacing.lg */.W.lg, spacing/* spacing.md */.W.md, spacing/* spacing.md */.W.md, spacing/* spacing.md */.W.md);

;// CONCATENATED MODULE: ./src/components/page-container/index.tsx


const PageContainer = (param)=>/*#__PURE__*/ {
    let { children  } = param;
    return (0,jsx_runtime.jsx)(PageContainerWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: children
        })
    });
};


/***/ }),

/***/ 7971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "V": function() { return /* binding */ PageTitle; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./src/constants/colors.tsx
var colors = __webpack_require__(9142);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 9 modules
var styled_components_browser_esm = __webpack_require__(4878);
;// CONCATENATED MODULE: ./src/components/page-title/styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}

const PageTitleContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8c0b114c-0"
})(_templateObject());

// EXTERNAL MODULE: ./src/components/typograph/index.tsx + 1 modules
var typograph = __webpack_require__(8234);
;// CONCATENATED MODULE: ./src/components/page-title/index.tsx




const PageTitle = (param)=>{
    let { title , description  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageTitleContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(typograph/* TypographH3 */.mr, {
                uppercase: true,
                bold: true,
                color: colors/* colors.green */.O.green,
                letterSpacing: 5,
                size: 14,
                lineHeight: 18.24,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(typograph/* TypographH1 */.Jx, {
                bold: true,
                uppercase: true,
                size: 40,
                color: colors/* colors.text_white */.O.text_white,
                children: description
            })
        ]
    });
};


/***/ }),

/***/ 7853:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "g": function() { return /* binding */ PillarGenericPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/constants/colors.tsx
var colors = __webpack_require__(9142);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 9 modules
var styled_components_browser_esm = __webpack_require__(4878);
// EXTERNAL MODULE: ./src/constants/spacing.tsx
var spacing = __webpack_require__(1036);
;// CONCATENATED MODULE: ./src/components/pillar-generic-page/styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  list-style-type: disc;\n  color: white;\n  gap: ",
        ";\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media (max-width: 750px) {\n    img {\n      max-width: 100% !important;\n      height: 200px !important;\n      object-fit: cover;\n    }\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}


const ParagraphsContainer = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-533dca04-0"
})(_templateObject(), spacing/* spacing.md */.W.md);
const Paragraph = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-533dca04-1"
})(_templateObject1());
const ResponsiveImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-533dca04-2"
})(_templateObject2());

// EXTERNAL MODULE: ./src/components/typograph/index.tsx + 1 modules
var typograph = __webpack_require__(8234);
// EXTERNAL MODULE: ./src/components/page-title/index.tsx + 1 modules
var page_title = __webpack_require__(7971);
// EXTERNAL MODULE: ./src/components/page-container/index.tsx + 1 modules
var page_container = __webpack_require__(5720);
// EXTERNAL MODULE: ./src/components/our-pillars/index.tsx + 1 modules
var our_pillars = __webpack_require__(4925);
// EXTERNAL MODULE: ./src/components/back-to-page-top/index.tsx + 1 modules
var back_to_page_top = __webpack_require__(1652);
;// CONCATENATED MODULE: ./src/components/match-with-your-company/styles.ts

function styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: ",
        ";\n\n  > a {\n    cursor: pointer;\n    transition: 0.25s;\n    background-color: ",
        ";\n    height: 48px;\n    margin-top: ",
        ";\n    align-self: end;\n    text-transform: uppercase;\n    letter-spacing: 5px;\n    font-size: 12px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    align-self: center;\n    @media (min-width: 750px) {\n      width: 416px;\n    }\n\n    @media (max-width: 750px) {\n      width: 100%;\n    }\n\n    &:hover {\n      filter: brightness(1.25);\n    }\n  }\n"
    ]);
    styles_templateObject = function() {
        return data;
    };
    return data;
}



const MatchWithYourCompanyContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-419b8c26-0"
})(styles_templateObject(), spacing/* spacing.md */.W.md, colors/* colors.green */.O.green, spacing/* spacing.sm */.W.sm);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/enums/routes.ts
var routes = __webpack_require__(4285);
;// CONCATENATED MODULE: ./src/components/match-with-your-company/index.tsx






const MatchWithYourCompany = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MatchWithYourCompanyContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(typograph/* TypographH2 */.rv, {
                bold: true,
                color: colors/* colors.green */.O.green,
                uppercase: true,
                letterSpacing: 6,
                lineHeight: 28.8,
                size: 24,
                children: "combina com a sua empresa?"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(typograph/* TypographSpan */.jA, {
                weak: true,
                size: 14,
                lineHeight: 22.4,
                color: colors/* colors.text_white */.O.text_white,
                letterSpacing: 4,
                uppercase: true,
                children: "estamos aqui para te ajudar a impulsionar seu neg\xf3cio e trazer resultados"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: routes/* RoutesEnum.contact */.Xv.contact,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typograph/* TypographSpan */.jA, {
                    uppercase: true,
                    bold: true,
                    color: colors/* colors.black */.O.black,
                    size: 12,
                    letterSpacing: 5,
                    lineHeight: 16.8,
                    children: "entre em contato"
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pillar-generic-page/index.tsx
/* eslint-disable react/no-array-index-key */ 









const PillarGenericPage = (param)=>{
    let { title , description , subdescription , image , paragraphs  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(page_container/* PageContainer */._, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(page_title/* PageTitle */.V, {
                title: title,
                description: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(typograph/* TypographP */.uQ, {
                color: colors/* colors.text_white */.O.text_white,
                size: 16,
                lineHeight: 20.24,
                bold: true,
                children: subdescription
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveImageWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: image,
                    alt: title
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ParagraphsContainer, {
                children: paragraphs.map((paragraph, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(typograph/* TypographSpan */.jA, {
                            color: colors/* colors.text_white */.O.text_white,
                            size: 14,
                            lineHeight: 18.24,
                            bold: true,
                            italic: true,
                            children: [
                                paragraph.main,
                                ":",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(typograph/* TypographSpan */.jA, {
                                    color: paragraph.greenContent ? colors/* colors.green */.O.green : colors/* colors.text_white */.O.text_white,
                                    size: 14,
                                    lineHeight: 18.24,
                                    weak: true,
                                    opacity: 0.8,
                                    children: paragraph.content
                                })
                            ]
                        })
                    }, String(index)))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(back_to_page_top/* BackToPageTop */.K, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(our_pillars/* OurPillars */.x, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MatchWithYourCompany, {})
        ]
    });
};


/***/ }),

/***/ 6200:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages_evolution_lifecycle; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./src/components/pillar-generic-page/index.tsx + 3 modules
var pillar_generic_page = __webpack_require__(7853);
;// CONCATENATED MODULE: ./public/evolution_lifecycle.png
/* harmony default export */ var evolution_lifecycle = ({"src":"/_next/static/media/evolution_lifecycle.32a23dc6.png","height":307,"width":932,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAYAAACuyE5IAAAAbklEQVR4nAFjAJz/AY+qi927uboiF/kd/SY3IwE1OzQA+/P8/wL4BAMJCgniAYSKg+HDwMQeHxggAO3t7QBjZmIA7e7tABAQEAABAQHtAScMKabZH9cpZVtfCAP4BvseBiHyEBIQAfj4+AQNDQ3pCtQmtyWmiOQAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":3});
;// CONCATENATED MODULE: ./src/pages/evolution-lifecycle/index.tsx



const DigitalBluePrintPage = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(pillar_generic_page/* PillarGenericPage */.g, {
        title: "Clareza na tomada de decis\xe3o",
        description: "Evolution Lifecycle",
        subdescription: "Em meio a tantas novidades tecnol\xf3gicas e pr\xe1ticas de mercado, entenda o que realmente \xe9 realmente agrega valor na jornada da sua empresa.",
        image: evolution_lifecycle,
        paragraphs: [
            {
                main: "Tend\xeancias",
                content: "Peneirar entre um mundo de tend\xeancias e focar na implanta\xe7\xe3o correta com um desenho de estrat\xe9gia que ajude seu neg\xf3cio a ser potencializado com o que h\xe1 de novo no mercado \xe9 um desafio que as empresas enfrentam no dia a dia. Auxiliar nesse momento e garantir os KPIs de sucesso fazem parte de nosso DNA."
            },
            {
                main: "Novos Modelos de Neg\xf3cio",
                content: "Investir em Novos Canais e Modelos de Neg\xf3cio. Somos desafiados constantemente em nossas empresas a abra\xe7ar as oportunidades, mas como tirar o maior proveito desses caminhos de maneira eficiente \xe9 nosso foco constante."
            },
            {
                main: "Solu\xe7\xf5es",
                content: "Novas solu\xe7\xf5es, plataformas, ferramentas. Conhecemos, testamos e conhecemos a fundo os diferenciais de cada ferramenta na pr\xe1tica e ajudamos a desenhar o stack perfeito de solu\xe7\xe3o para seu neg\xf3cio."
            },
            {
                main: "Business Cases",
                content: "Na maioria das vezes o desenho correto do business case \xe9 o maior gargalo para permitir e dar consist\xeancia aos projetos de inova\xe7\xe3o e evolu\xe7\xe3o da jornada digital. Identificar e construir o modelo correto \xe9 essencial para garantir o sucesso do projeto."
            }
        ]
    });
/* harmony default export */ var pages_evolution_lifecycle = (DigitalBluePrintPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [664,774,888,179], function() { return __webpack_exec__(4123); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);